export {default} from './share-prompt.vue'